/**
 * Date formatting
 */
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_HUMAN = 'dd/mm/yyyy';
export const TIME_FORMAT = 'HH:mm';
export const TIME_FORMAT_HUMAN = 'HH:MM';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DATE_TIME_FORMAT_HUMAN = `${DATE_FORMAT_HUMAN} ${TIME_FORMAT_HUMAN}`;
